module.exports = __webpack_public_path__ + "static/assets/329ed0ca87b67705aa4a08eef0bddde7.png";